import React, { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { imgUrl } from "@/lib/apiClient";

export const FlavorCard = ({ flavor, price = 5, onAdd }) => {
  const images = flavor.images && flavor.images.length ? flavor.images : [flavor.image];
  const [active, setActive] = useState(0);

  return (
    <div
      data-testid={`flavor-card-${flavor.id}`}
      className="group overflow-hidden rounded-2xl border border-ashy/30 bg-white transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative h-56 overflow-hidden">
        <img
          src={imgUrl(images[active])}
          alt={flavor.name}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
      </div>

      {images.length > 1 && (
        <div className="flex gap-2 px-4 pt-4">
          {images.slice(0, 5).map((img, i) => (
            <button
              key={i}
              data-testid={`flavor-thumb-${flavor.id}-${i}`}
              onMouseEnter={() => setActive(i)}
              onClick={() => setActive(i)}
              className={`h-12 w-12 overflow-hidden rounded-lg border-2 transition-colors ${
                active === i ? "border-cocoa" : "border-transparent opacity-70 hover:opacity-100"
              }`}
            >
              <img src={imgUrl(img)} alt="" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}

      <div className="p-6">
        <h3 className="font-heading text-2xl font-bold text-ink">{flavor.name}</h3>
        <p className="mt-2 min-h-[40px] text-sm text-ashydark">{flavor.description}</p>
        <div className="mt-5 flex items-center justify-between">
          <span className="font-heading text-xl font-bold text-cocoa">${Number(price).toFixed(2)}</span>
          <Button
            data-testid={`add-single-${flavor.id}`}
            onClick={() => onAdd(flavor)}
            className="rounded-full bg-babyblue px-5 text-cocoadark transition-transform duration-300 hover:-translate-y-0.5 hover:bg-babyblue/80"
          >
            <Plus className="mr-1 h-4 w-4" /> Add
          </Button>
        </div>
      </div>
    </div>
  );
};
